(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/race-service/assets/javascripts/use-race-jackpots.js') >= 0) return;  svs.modules.push('/components/racing/race-service/assets/javascripts/use-race-jackpots.js');

'use strict';

const {
  useEffect,
  useState,
  useCallback
} = React;
const {
  fetchJackpots
} = svs.racing.raceService;
const logger = svs.core.log.getLogger('racing-service.use-race-jackpots');
const {
  gameTypes,
  gameTypeToSubProductId
} = svs.racing.common.constants;
const useRaceJackpots = () => {
  const [jackpots, setJackpots] = useState([]);
  useEffect(() => {
    fetchJackpots((err, response) => {
      if (err) {
        logger.info("fetch-jackpots-error: ".concat(err.error));
        setJackpots(undefined);
      } else {
        const jp = response || [];
        setJackpots(jp);
      }
    });
  }, []);
  const getAllJackpots = useCallback(() => {
    if (jackpots === undefined || jackpots.length === 0) {
      return undefined;
    }
    return jackpots;
  }, [jackpots]);
  const getFirstJackpot = useCallback(raceId => {
    var _getAllJackpots;
    const jackpots = (_getAllJackpots = getAllJackpots()) === null || _getAllJackpots === void 0 || (_getAllJackpots = _getAllJackpots.filter(jackpotId => jackpotId.raceId === raceId)) === null || _getAllJackpots === void 0 ? void 0 : _getAllJackpots[0];
    return jackpots;
  }, [getAllJackpots]);
  const getJackpot = useCallback(raceId => {
    if (jackpots === undefined || jackpots.length === 0) {
      return undefined;
    }
    for (let i = 0; i < jackpots.length; i++) {
      if (jackpots[i].raceId === raceId) {
        for (let j = 0; j < jackpots[i].jackpots.length; j++) {
          if (jackpots[i].jackpots[j].userProduct === gameTypeToSubProductId[gameTypes.TOPP5]) {
            return jackpots[i];
          }
        }
      }
    }
    return undefined;
  }, [jackpots]);
  return {
    getJackpot,
    getAllJackpots,
    getFirstJackpot
  };
};
svs.racing.raceService.useRaceJackpots = useRaceJackpots;

 })(window);